const getters = {
  menu: state => state.permission.menu,
  user: state => state.user.user,
  dict: state => state.dict.dict,
  allLoading: state => state.permission.allLoading
}
export default getters
